<template>
    <div class="component-container">
        <template v-if="errorMessage !== null">
            {{ errorMessage }}
        </template>
        <template v-else>
            <template v-if="jobCreated === false">
                <template v-if="creatingJob === false">
                    <h4>{{ 'New appointment to continue this job' | trans }}</h4>
                    <div class="row">
                        <div class="col-xs-8">
                            <strong>{{ 'Job description' | trans}}:</strong><br>
                            {{ originalJob.jobTypesChainTranslated.join(' > ') }}. {{ originalJob.jobDescription }}
                        </div>
                        <div class="col-xs-4">
                            <strong>{{ 'Time required' | trans}}:</strong>
                            <select
                                    v-model="durationRequired"
                                    class="form form-control">
                                <option
                                        v-for="durationRequiredOption in durationRequiredOptions"
                                        v-bind:value="durationRequiredOption.value">
                                    {{ durationRequiredOption.label }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12">
                            <strong>{{ 'Your comment' | trans}}:</strong>
                            ({{ '%number% characters min.' | trans({number: '10'}) }})<br>
                            <input
                                    v-model="remark"
                                    type="text"
                                    class="form form-control" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12">
                            <SlotSuggestion
                                    v-if="remarkIsValid"
                                    v-bind:originalJobId="originalJob.id"
                                    v-bind:durationRequired="durationRequired"
                                    v-bind:customerAddressZipCode="originalJob.customerAddressIntervention.zipCode"
                                    v-on:slot:selected="createContinuationJob">
                            </SlotSuggestion>
                            <button
                                    v-else
                                    disabled
                                    class="small-btn-close-input btn-primary btn full-width">
                                {{ 'Continuer' | trans }}
                            </button>
                        </div>
                    </div>
                </template>
                <Spinner
                        v-else
                        v-bind:title="'Creating job...' | trans">
                </Spinner>

                <div class="alert alert-danger" v-if="isMessageShownBeforeTimeOut">
                    {{'It takes longer than expected, please wait a moment or check your internet connexion'|trans}}
                </div>

            </template>
            <div
                    v-else
                    class="row">
                <div class="col-xs-12">
                    <div class="alert alert-success">
                        <strong>{{ 'Thank you, the job has been added on %date%' | trans({date: formatDate(jobCreatedDateJobStart)}) }}</strong>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import SlotSuggestion from './SlotSuggestion';
    import Spinner from '../Spinner';
    import moment from 'moment';

    export default {
        components: {Spinner, SlotSuggestion},
        props: {
            originalJob: Object
        },
        data() {
            return {
                remark: '',
                durationRequired: 60,
                creatingJob: false,
                jobCreated: false,
                jobCreatedDateJobStart: null,
                errorMessage: null,
                timeout : 1000*30,
                isMessageShownBeforeTimeOut : false,
                limitBeforeTimeOut : 1000*6,
                timer : null
            };
        },
        methods: {
            async createContinuationJob(slot) {
                this.startRequestWithTimeOutMessage();
                this.creatingJob = true;
                const dateJobStartString = slot.day + ' ' + slot.time;
                try {
                    await this.$api.job.createContinuationJob(this.originalJob.id, dateJobStartString, this.durationRequired, this.remark, this.timeout);
                    this.jobCreatedDateJobStart = dateJobStartString;
                    this.jobCreated = true;
                    this.stopRequestWithTimeOutMessage();
                }
                catch (error) {
                    this.stopRequestWithTimeOutMessage();
                    if (this.$api.is401(error)) {
                        // in case of 401, just abort javascript execution
                        return;
                    }
                    if (this.$api.isNoConnectivity(error)) {
                        this.errorMessage = this.$options.filters.trans('No connection ?');
                    } else {
                        this.$bugsnagClient.notify(error);
                        this.errorMessage = this.$options.filters.trans('Unknown error');
                    }
                }
                this.creatingJob = false;
            },
            startRequestWithTimeOutMessage(){
                this.timer = setInterval(() => {
                        this.isMessageShownBeforeTimeOut = true;
                }, this.limitBeforeTimeOut);
            },
            stopRequestWithTimeOutMessage(){
                clearTimeout(this.timer);
            },
            formatDate(dateString) {
                const momentDay = moment(dateString);
                return momentDay.format('dddd D MMMM [@] HH[h]mm');
            }
        },
        computed: {
            remarkIsValid() {
                return this.remark.length >= 10;

            },
            durationRequiredOptions() {
                return [
                    {value: 40, label: '40 min.'},
                    {value: 60, label: '1h00'},
                    {value: 80, label: '1h20'},
                    {value: 120, label: '2h00'},
                    {value: 180, label: '3h00'},
                    {value: 360, label: '6h00'},
                    {value: 540, label: '9h00'}
                ];
            }
        }
    }
</script>

<style scoped>
    .component-container {
        padding: 0 10px;
    }
</style>
